import { render } from "./WenAn.vue?vue&type=template&id=27d7175f&scoped=true"
import script from "./WenAn.vue?vue&type=script&lang=js"
export * from "./WenAn.vue?vue&type=script&lang=js"

import "./WenAn.vue?vue&type=style&index=0&id=27d7175f&scoped=true&lang=scss"
import "./WenAn.vue?vue&type=style&index=1&id=27d7175f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d7175f"]])

export default __exports__